import { VerifiedProfileIcon } from "./icons.tsx"

export const UserProfile = ({ name }: { name: string }) => {
  return (
    <div className="flex items-center justify-center gap-2">
      <VerifiedProfileIcon />
      <span className="uppercase text-[11px] leading-[16px] tracking-upper font-departure-mono">{name}</span>
    </div>
  )
}
